module.exports = __webpack_public_path__ + "img/player_damage_001.1aba36fc.png";